import React, { useState } from "react";
import classNames from "classnames";
import { Form, InputGroup } from "react-bootstrap";

/* Password Input */
const PasswordInput = ({
  name,
  placeholder,
  refCallback,
  register,
  className,
  errorText,
  ...otherProps
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <InputGroup className="mb-0">
        <Form.Control
          type={showPassword ? "text" : "password"}
          placeholder={placeholder}
          name={name}
          id={name}
          as="input"
          ref={(r) => {
            if (refCallback) refCallback(r);
          }}
          className={className}
          {...(register ? register(name) : {})}
          autoComplete={name}
          {...otherProps}
        />
        {/* Show/hide toggle logic can be uncommented if needed */}
        {/* <div
                    className={classNames('input-group-text', 'input-group-password', {
                        'show-password': showPassword,
                    })}
                    data-password={showPassword ? 'true' : 'false'}
                >
                    <span
                        className="password-eye"
                        onClick={() => setShowPassword(!showPassword)}
                    ></span>
                </div> */}
      </InputGroup>
    </>
  );
};

const FormInput = ({
  label,
  type,
  name,
  placeholder,
  register,
  className,
  labelClassName,
  containerClass,
  refCallback,
  children,
  rows,
  errorText,
  ...otherProps
}) => {
  const comp =
    type === "textarea" ? "textarea" : type === "select" ? "select" : "input";

  if (type === "hidden") {
    return (
      <input
        type={type}
        name={name}
        {...(register ? register(name) : {})}
        {...otherProps}
      />
    );
  }

  return (
    <>
      {type === "password" ? (
        <Form.Group className={containerClass}>
          {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
          {children}
          <PasswordInput
            name={name}
            placeholder={placeholder}
            refCallback={refCallback}
            register={register}
            className={className}
            {...otherProps}
          />
          {errorText && (
            <Form.Control.Feedback type="invalid" className="d-block">
              {errorText}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      ) : type === "checkbox" || type === "radio" ? (
        <Form.Group className={containerClass}>
          <Form.Check
            type={type}
            label={label}
            name={name}
            id={name}
            ref={(r) => {
              if (refCallback) refCallback(r);
            }}
            className={`${className} align-middle`}
            {...(register ? register(name) : {})}
            {...otherProps}
          />
          {errorText && (
            <Form.Control.Feedback type="invalid" className="d-block">
              {errorText}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      ) : type === "select" ? (
        <Form.Group className={containerClass}>
          {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
          <Form
            type={type}
            placeholder={placeholder}
            name={name}
            id={name}
            as={comp}
            ref={(r) => {
              if (refCallback) refCallback(r);
            }}
            className="form-control"
            {...(register ? register(name) : {})}
            rows={rows}
            {...otherProps}
            autoComplete={name}
          >
            {children}
          </Form>
          {errorText && (
            <Form.Control.Feedback type="invalid" className="d-block">
              {errorText}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      ) : (
        <Form.Group className={containerClass}>
          {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
          <Form.Control
            type={type}
            placeholder={placeholder}
            name={name}
            id={name}
            as={comp}
            ref={(r) => {
              if (refCallback) refCallback(r);
            }}
            className={className}
            {...(register ? register(name) : {})}
            rows={rows}
            {...otherProps}
            autoComplete={name}
          >
            {children}
          </Form.Control>
          {errorText && (
            <Form.Control.Feedback type="invalid" className="d-block">
              {errorText}
            </Form.Control.Feedback>
          )}
        </Form.Group>
      )}
    </>
  );
};

export default FormInput;
